module.exports = __webpack_public_path__ + "img/logo-transparent.4c38c5e9.svg";